import { render, staticRenderFns } from "./GlobaMenu.vue?vue&type=template&id=715d61e6"
import script from "./GlobaMenu.vue?vue&type=script&lang=js"
export * from "./GlobaMenu.vue?vue&type=script&lang=js"
import style0 from "./GlobaMenu.vue?vue&type=style&index=0&id=715d61e6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports